import { render, staticRenderFns } from "./BusinessCategories.vue?vue&type=template&id=d0b35ca0&scoped=true&"
import script from "./BusinessCategories.vue?vue&type=script&lang=js&"
export * from "./BusinessCategories.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCategories.vue?vue&type=style&index=0&id=d0b35ca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b35ca0",
  null
  
)

export default component.exports